<template>
	<div class="onlineExam">
	    <div class="onlineExam_center">
			<div class="onlineExam_center" style="display: flex;justify-content: space-between; align-items: center;">
				<div class="title">考试题目</div>
				<div>
					<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;" type="primary" @click="$router.go(-1)">返回</el-button>
				</div>
			</div>
			
            <div class="onlineExam_center_top">
                <span>题目数：{{ allQuestion.length }}</span>
                <span>考试时长：{{ durationTime }}分钟</span>
                <!-- <span>考试时间：{{ allQuestion.length }}</span> -->
                <span>考试总分：{{ totalStore }}</span>
                <span>及格分数：{{ passSrore }}</span>
			</div>
			<div class="onlineExam_question_List">
                <div class="onlineExam_question_List_left">
					<!-- 单选 -->
					<div class="questionList_item" v-for="(item,i) in allQuestion" :key="item.qid">
						<!-- 标题 -->
						<div class="questionList_item_top_title">
                            {{i+1}}、{{ item.title }}({{ item.type }}) 
						</div>
						<div class="question_options"   v-if="item.type=='单选'||item.type=='判断'"  v-for="(items) in item.option">
							<el-radio-group @input="rideoChange" v-model="item.answer">
								<el-radio :label="items.title" >{{ items.title }}：{{ items.content }}</el-radio>
						    </el-radio-group>
						</div>
						<!-- 多选 -->
					      	<el-checkbox-group v-if="item.type=='多选'"  @change="checkBoxChange"
						     	v-model="item.answer"
								>
									<el-checkbox style="display: block;margin-top: 10px;margin-top: 10px;" v-for="(items,indexs) in item.option" :label="items.title" :key="indexs">{{ items.title }}：{{ items.content }}</el-checkbox>
							</el-checkbox-group>
						<!-- 选项 -->
					</div>
				</div>
                <div class="onlineExam_question_List_right">
					<div class="onlineExam_question_List_right_top">答题卡</div>
					<div class="onlineExam_question_List_right_bottom">
						<div class="answer_item" :style="{color:item.answer!=''&item.answer!=[]?'#fff':'',backgroundColor:item.answer!=''&item.answer!=[]?'#EE632B':''}" v-for="(item,index) in allQuestion">
							{{ index+1 }}
						</div>
						
					</div>
				</div>
			</div>
			<div  class="submitExam">
				<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;" type="primary" @click="submitExam">提交</el-button>
								<el-button @click="this.$router.go(-1)">取消</el-button>
			</div>
		</div>
	</div>
</template>
<script>
	import { user } from '@/axios';
	export default{
		data(){
			
			return{
				getdata:{
					uid:this.$store.state.user.userinfo2.id,
					tid:this.$route.query.tid,
					aid:this.$route.query.aid,
				},
				datacheng:[],
				singleList:[],
				moreList:[],
				judgeList:[],
				allQuestion:[],
				totalStore:'',
				passSrore:'',
				durationTime:'',
				singleCheck:[],
				moreCheck:[],
                submitDate:[]

			}
		},
		
		methods:{
			rideoChange(val){
		
				this.$forceUpdate();
			},
			checkBoxChange(val){
			
				this.$forceUpdate();
			},
			// 获取试卷详情
			getExamDetail(){
				let that=this
				user.ExamDetail(that.getdata).then(res=>{
					if (res.code==200) {
					
						that.singleList=res.data.single
						that.singleList.forEach((item,index,arr) => {
							arr[index].type='单选'
							arr[index].answer=''
							// arr[index].options=[]
							// item.option.forEach(item=>{
							// 	arr[index].options.push(item.title+'：'+item.content)
							// })
						});
						that.moreList=res.data.more
						that.moreList.forEach((item,index,arr) => {
							arr[index].type='多选'
							arr[index].answer=[]
							// arr[index].options=[]
							// item.option.forEach(item=>{
							// 	arr[index].options.push(item.title+'：'+item.content)
							// })
							
						});
						that.judgeList=res.data.judge
						that.judgeList.forEach((item,index,arr) => {
							arr[index].type='判断'
							arr[index].answer=''
							
							// item.option.forEach(item=>{
							// 	arr[index].options.push(item.title+'：'+item.content)
							// })
						});
						that.passSrore=res.data.pass
						that.durationTime=res.data.duration
						that.totalStore=res.data.total 
						
                        that.allQuestion=[...that.singleList,...that.moreList,...that.judgeList]
					
					}
				})
			},
			// 提交试卷
			submitExam(){
				let that=this
				this.submitDate=[]
				this.allQuestion.forEach(item=>{
                     let obj={}
					 obj.qid=item.qid
					 obj.answer=[]
					 if (item.type=='单选'||item.type=='判断') {
						obj.answer.push(item.answer.substring(2,3))
					 }else{
						item.answer.forEach(items=>{
							obj.answer.push(items.substring(2,3))
						})
					 }
					 that.submitDate.push(obj)
					 
				})
				
				that.getdata.answer=that.submitDate
				// 向服务器发起请求提交试卷
				that.$confirm('提交试卷后不可更改', '提交试卷', {
					cancelButtonText: '取消',
					confirmButtonText: '确定提交',
					type: 'warning'
				}).then(() => {
					// 确定
				
					user.makeTest( that.getdata).then(res=>{
						if (res.code==200) {
							this.$message({
							message: '提交成功',
							type: 'success'
						    });
							this.$router.go(-1)
						}
					})

				}).catch(() => {
					// 取消
					
				});
			}
			
		  },
		mounted(){
			this.getExamDetail()
		},
		created() {
			this.$emit("highLight",0,"","","");
		}
	}
</script>

<style lang="scss">
.onlineExam{
	width: 100%;
	height: 100%;
	background-color: #F9F9F9;
	min-height: 400px;
	.onlineExam_center{
		padding-top: 10px;
		width: 1200px;
		margin: 0 auto;
		
		.title{
			margin-top: 10px;
			height: 40px;
			line-height: 40px;
			font-weight: bold;
			font-size: 18px;
			color: #202020;
		}
		.onlineExam_center_top{
			display: flex;
			justify-content: space-between;
			width: 100%;
			height: 20px;
			font-family: PingFangSC-Regular;
			font-size:16px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;

			color: #999999;
			margin-bottom: 30px;
		}
		.onlineExam_question_List{
			width: 100%;
			display: flex;
			justify-content: space-between;
			.onlineExam_question_List_left{
				width: 880px;
				
				.questionList_item{
					margin-bottom: 30px;
					box-sizing: border-box;
					padding: 20px;
					width: 100%;
					background-color: #fff;
                   .questionList_item_top_title{
					color: #1E2129;
					font-size: 14px;
					font-weight: bold;
					margin-bottom: 15px;
				   }
				   .question_options{
					margin-top: 15px;
				   }
					
					
				}
			}
			.onlineExam_question_List_right{
				width: 288px;
				height: 350px;
				background-color: #fff;
				.onlineExam_question_List_right_top{
					width: 100%;
					height: 35px;
					background-color: #EE632B;
					color: #fff;
					font-size: 20px;
					line-height: 35px;
					text-align: center;
				}
				.onlineExam_question_List_right_bottom{
					width: 100%;
					height: 315px;
					overflow-y: auto;
					box-sizing: border-box;
					padding: 10px;
					display: flex;
					flex-wrap: wrap;
					align-content: start;
                    .answer_item{
						margin-right: 20px;
                        width: 32px;
						height: 32px;
						border: 1px solid rgb(206,0,13);
						border-radius: 4px;
						color: #333;
						font-size: 18px;
						text-align: center;
						line-height: 32px;
						margin-bottom: 20px;
					}
					.answer_item:nth-child(5n){
						margin-right: 0;
					}
				}
                 
			}
			
		}
		.submitExam{
			text-align: center;
			margin-bottom: 40px;
		}
	}
}
	
		
			
</style>
